import concurrent_device_limit from './concurrent-device-limit.js';
const application_details = {
    page_title: '應用詳細資料',
    back_to_applications: '返回全部應用',
    check_guide: '查看指南',
    settings: '設置',
    settings_description: '「應用程式」是已註冊的軟體或服務，可存取使用者資訊或代表使用者執行操作。應用程式協助Logto辨識誰在請求哪些資源，並負責處理登入與授權。請填寫必要欄位以完成驗證。',
    integration: '整合',
    integration_description: '使用由Cloudflare邊緣網路提供動力的Logto安全工作者部署，實現全球頂級性能和 0 毫秒全球冷啟動。',
    service_configuration: '服務配置',
    service_configuration_description: '在您的服務中完成必要的配置。',
    session: '會話',
    endpoints_and_credentials: '端點與憑證',
    endpoints_and_credentials_description: '使用以下端點和憑證設置應用程式中的開放身分連接（OIDC）連接。',
    refresh_token_settings: '刷新令牌',
    refresh_token_settings_description: '管理此應用程式的刷新令牌規則。',
    machine_logs: '機器日誌',
    application_name: '應用程式姓名',
    application_name_placeholder: '我的應用程式',
    description: '說明',
    description_placeholder: '請輸入應用程式說明',
    config_endpoint: 'OpenID 提供者設定端點',
    issuer_endpoint: '發行者端點',
    jwks_uri: '公開金鑰集位址',
    authorization_endpoint: '授權端點',
    authorization_endpoint_tip: '進行驗證與授權的端點。用於開放身分連接中的 <a>驗證</a> 流程。',
    show_endpoint_details: '顯示端點詳情',
    hide_endpoint_details: '隱藏端點詳情',
    logto_endpoint: 'Logto端點',
    application_id: '應用程式識別碼',
    application_id_tip: '應用程式的唯一標識，通常由Logto生成。相當於開放身分連接中的 <a>client_id</a>。',
    application_secret: '應用程式秘鑰',
    application_secret_other: '應用程式秘鑰',
    redirect_uri: '重定向位址',
    redirect_uris: '重新導向 URI',
    redirect_uri_placeholder: 'https://your.website.com/app',
    redirect_uri_placeholder_native: 'io.logto://callback',
    redirect_uri_tip: '在用戶登錄完成（不論成功與否）後，重新導向的目標位址。參見開放身分連接 <a>AuthRequest</a> 以了解更多。',
    mixed_redirect_uri_warning: '你的應用程式類型不相容於至少一個重定向位址。這不符合最佳實踐，我們強烈建議保持重定向位址一致。',
    wildcard_redirect_uri_warning: '萬用字元重定向位址不是標準開放身分連接（OIDC），可能會增加攻擊面。請謹慎使用，儘可能使用精確的重定向位址。',
    post_sign_out_redirect_uri: '登出後重定向的位址',
    post_sign_out_redirect_uris: '登出後重定向的URIs',
    post_sign_out_redirect_uri_placeholder: 'https://your.website.com/home',
    post_sign_out_redirect_uri_tip: '在用戶登出後，重新導向的目標位址（可選）。在某些應用程式類型中可能無實質作用。',
    cors_allowed_origins: '跨來源資源共用允許的來源',
    cors_allowed_origins_placeholder: 'https://your.website.com',
    cors_allowed_origins_tip: '所有重新導向位址的來源都將默認被允許。通常不需要對此欄位進行操作。參見 <a>MDN文件</a> 以了解更多。',
    token_endpoint: '權杖端點',
    user_info_endpoint: '用戶資訊端點',
    enable_admin_access: '啟用管理訪問',
    enable_admin_access_label: '啟用或禁用對管理介面的訪問。啟用後，你可以使用訪問令牌代表該應用程式調用管理介面。',
    always_issue_refresh_token: '始終發放更新權杖',
    always_issue_refresh_token_label: '啟用此配置將使Logto無論在驗證請求中是否提供prompt=consent，都能始終發放更新權杖。然而，除非必要，否則不鼓勵這種做法，因為它與開放身分連接不相容並可能引起問題。',
    refresh_token_ttl: '更新權杖有效期（天數）',
    refresh_token_ttl_tip: '更新權杖可用來獲取新的訪問令牌，失效日期之前可用。獲取訪問令牌時，該令牌的期限將被延長至此值。',
    rotate_refresh_token: '輪換更新權杖',
    rotate_refresh_token_label: '啟用此配置將使Logto當更新權杖的原始有效期剩下 70% 時或當滿足某些條件時，授予新的更新權杖以獲取新的存取權杖。<a>了解更多</a>',
    rotate_refresh_token_label_for_public_clients: '啟用後，Logto將為每個令牌請求發放新的刷新令牌。<a>了解更多</a>',
    backchannel_logout: '後台登出',
    backchannel_logout_description: '配置開放身分連接後台登出端點以及此應用程式是否需要會話。',
    backchannel_logout_uri: '後台登出位址',
    backchannel_logout_uri_session_required: '需要會話嗎？',
    backchannel_logout_uri_session_required_description: '啟用後，RP要求logout權杖中包含 `sid`（會話識別碼）聲明，以便當使用 `backchannel_logout_uri` 時識別RP與OP的會話。',
    token_exchange: '權杖交換',
    token_exchange_description: '管理此應用程式的權杖交換設定。',
    allow_token_exchange: '允許權杖交換',
    allow_token_exchange_description: '允許此應用程式發起權杖交換請求。這是 <impersonationLink>使用者冒充</impersonationLink> 與 <patLink>個人存取權杖</patLink> 所必需的。',
    allow_token_exchange_public_client_warning: '不建議為公開用戶端（單頁應用／原生應用）啟用權杖交換。公開用戶端無法安全儲存憑證，可能使你的應用暴露於權杖冒充風險。',
    device_flow_tag: '裝置流程',
    device_flow_notification: '此應用程式啟用了開放授權（OAuth）2.0 裝置授權流程，適用於輸入受限的裝置或無介面應用程式（如電視、命令列介面）。使用者可在另一台裝置上輸入裝置碼或掃描 QR 圖碼完成登入。<a>瞭解更多</a>',
    device_flow_try_demo: '試用示範',
    delete_description: '本操作會永久性地刪除該應用程式，且不可撤銷。輸入 <span>{{name}}</span> 確認。',
    enter_your_application_name: '輸入你的應用程式姓名',
    application_deleted: '應用 {{name}} 成功刪除。',
    redirect_uri_required: '至少需要輸入一個重定向網址。',
    app_domain_description_1: '隨時使用由Logto提供動力的 {{domain}} 域，其永久有效。',
    app_domain_description_2: '隨時使用您的域 <domain>{{domain}}</domain>，其永久有效。',
    custom_rules: '自定義身份驗證規則',
    custom_rules_placeholder: '^/(admin|privacy)/.+$',
    custom_rules_description: '使用正則表達式設置需要身份驗證的路徑規則。預設: 若留空則全站保護。',
    authentication_routes: '身份驗證路徑',
    custom_rules_tip: "這裡有兩個案例：<ol><li>僅對 '/admin' 和 '/privacy' 路徑進行身份驗證: ^/(admin|privacy)/.*</li><li>排除JPG圖片不進行身份驗證: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: '使用指定路徑重新導向您的身份驗證按鈕。注意: 這些路徑不可替代。',
    protect_origin_server: '保護您的源伺服器',
    protect_origin_server_description: '確保保護您的源伺服器免受直接訪問。請參閱指南以獲取更多 <a>詳細說明</a>。',
    third_party_settings_description: '使用開放身分連接（OIDC） / 開放授權（OAuth） 2.0 將第三方應用程序與Logto作為你的身份提供者(身分提供者)整合，並提供用戶授權的同意頁面。',
    session_duration: '會話持續時間（天數）',
    try_it: '試試看',
    no_organization_placeholder: '未找到組織。<a>前往組織</a>',
    field_custom_data: '自定義資料',
    field_custom_data_tip: '額外的自定義應用資訊，不在預定義的應用屬性中，例如業務特定的設置和配置。',
    custom_data_invalid: '自定義資料必須是有效的JavaScript物件表示法（JSON）對象',
    access_control: {
        name: '規則',
        title: '存取控制',
        description: '自訂應用程式層級存取控制規則。',
        enable: '啟用應用程式層級存取控制',
        enable_description: '啟用精細化存取控制，以限制哪些使用者可以存取此應用程式。如果停用，系統中的所有已註冊使用者都可以存取。',
        enable_without_rules_notice: '請先新增至少一條存取規則，再啟用存取控制。',
        load_error: '載入存取控制規則失敗。',
        custom_allow_rules: '自訂允許規則',
        custom_allow_rules_description: '建立規則，讓具備特定屬性的使用者可以自動存取。啟用時至少需要一條規則。',
        rules: '存取規則',
        add_rules: '新增規則',
        rules_description: '使用者符合任一條已配置規則時即可存取此應用程式。',
        empty_rules_description: '尚未配置任何規則。',
        delete_rule_confirmation: '確定要移除此規則嗎？',
        rule_table_rules: '規則',
        rule_table_description: '描述',
        rule_table_users: '使用者',
        rule_table_members: '成員',
        rule_table_user_id: '使用者識別碼',
        rule_count: '{{count}} 條規則',
        rule_count_other: '{{count}} 條規則',
        rule_users: '使用者',
        rule_users_description: '指定使用者可以存取此應用程式。',
        rule_roles: '角色',
        rule_user_roles: '使用者角色',
        rule_user_roles_description: '擁有所選使用者角色的使用者可以存取此應用程式。',
        rule_organizations: '組織',
        rule_organizations_description: '所選組織中的目前與未來成員都可以存取此應用程式。',
        rule_organization_roles: '組織角色',
        rule_organization_roles_description: '在所選組織中擁有所選組織角色的成員可以存取此應用程式。',
    },
    branding: {
        name: '品牌',
        description: '在同意畫面上自訂應用程式的顯示名稱和標誌。',
        description_third_party: '自訂應用程式的顯示名稱和標誌在同意畫面上。',
        app_logo: '應用圖標',
        app_level_sie: '應用層級登入體驗',
        app_level_sie_switch: '啟用應用層級登入體驗，並設置應用特定的品牌。如果禁用，將使用全局登入體驗。',
        more_info: '更多資訊',
        more_info_description: '在同意畫面上提供有關您的應用程式的更多詳細資訊。',
        display_name: '顯示名稱',
        application_logo: '應用程式標誌',
        application_logo_dark: '應用程式標誌（深色）',
        brand_color: '品牌顏色',
        brand_color_dark: '品牌顏色（深色）',
        terms_of_use_url: '應用程式使用條款網址',
        privacy_policy_url: '應用程式隱私政策網址',
    },
    permissions: {
        name: '權限',
        description: '選擇第三方應用程式需要的許可權，以便用戶授權訪問特定資料類型。',
        user_permissions: '個人用戶資料',
        organization_permissions: '組織訪問',
        table_name: '授予權限',
        field_name: '權限',
        field_description: '在同意畫面上顯示',
        delete_text: '刪除權限',
        permission_delete_confirm: '此操作將撤銷授予第三方應用程式的權限，防止其要求授權訪問特定資料類型。確定要繼續嗎？',
        permissions_assignment_description: '選擇第三方應用程式請求用戶授權訪問特定資料類型的權限。',
        user_profile: '用戶資料',
        api_permissions: '介面權限',
        organization: '組織權限',
        user_permissions_assignment_form_title: '添加用戶資料權限',
        organization_permissions_assignment_form_title: '添加組織權限',
        api_resource_permissions_assignment_form_title: '添加介面資源權限',
        user_data_permission_description_tips: '你可以通過「登入體驗 > 內容 > 管理語言」修改個人用戶資料權限的描述。',
        permission_description_tips: '當Logto作為第三方應用程式中的身份提供者（身分提供者）用於身份驗證時，用戶被要求授權，此描述將顯示在同意畫面上。',
        user_title: '用戶',
        user_description: '選擇由第三方應用程式請求的用於訪問特定用戶資料的權限。',
        grant_user_level_permissions: '授予用戶資料權限',
        organization_title: '組織',
        organization_description: '選擇由第三方應用程式請求的用於訪問特定組織資料的權限。',
        grant_organization_level_permissions: '授予組織資料權限',
        oidc_title: '開放身分連接（OIDC）',
        oidc_description: '核心開放身分連接（OIDC）權限會自動為你的應用程式設定。這些範圍對驗證至關重要，且不會顯示於使用者同意畫面。',
        default_oidc_permissions: '預設開放身分連接（OIDC）權限',
        permission_column: '權限',
        guide_column: '指南',
        openid_permission: 'openid',
        openid_permission_guide: "用於存取開放授權（OAuth）資源時為選填。\n用於開放身分連接（OIDC）驗證時為必填。授予存取身分權杖的權限，並允許存取 'userinfo_endpoint'。",
        offline_access_permission: 'offline_access',
        offline_access_permission_guide: '選填。取得刷新令牌，用於長期存取或背景任務。',
    },
    roles: {
        assign_button: '分配機器對機器角色',
        delete_description: '此操作將從此機器到機器應用程式中刪除該角色。該角色本身仍然存在，但不再與此機器到機器應用程式關聯。',
        deleted: '已成功從此用戶中刪除 {{name}}。',
        assign_title: '將機器對機器角色分配給 {{name}}',
        assign_subtitle: '機器對機器應用程式必須具有機器對機器類型的角色才能訪問相關的介面資源。',
        assign_role_field: '分配機器對機器角色',
        role_search_placeholder: '按角色名稱搜索',
        added_text: '{{value, number}} 已添加',
        assigned_app_count: '{{value, number}} 應用程式',
        confirm_assign: '分配機器對機器角色',
        role_assigned: '成功分配角色',
        search: '按角色名稱、描述或識別碼搜索',
        empty: '沒有可用的角色',
    },
    secrets: {
        value: '值',
        empty: '應用程式沒有任何秘鑰。',
        created_at: '創建於',
        expires_at: '到期於',
        never: '從不',
        create_new_secret: '創建新秘鑰',
        delete_confirmation: '此操作無法撤銷。你確定要刪除此秘鑰嗎？',
        deleted: '秘鑰已成功刪除。',
        activated: '秘鑰已成功啟用。',
        deactivated: '秘鑰已成功停用。',
        legacy_secret: '舊版秘鑰',
        expired: '已過期',
        expired_tooltip: '此秘鑰已於 {{date}} 過期。',
        create_modal: {
            title: '創建應用程式秘鑰',
            expiration: '到期',
            expiration_description: '秘鑰將於 {{date}} 到期。',
            expiration_description_never: '秘鑰不會過期。我們建議設置到期日期以增強安全性。',
            days: '{{count}} 天',
            days_other: '{{count}} 天',
            years: '{{count}} 年',
            years_other: '{{count}} 年',
            created: '秘鑰 {{name}} 創建成功。',
        },
        edit_modal: {
            title: '編輯應用程式秘鑰',
            edited: '秘鑰 {{name}} 編輯成功。',
        },
    },
    saml_idp_config: {
        title: '安全斷言標記語言（SAML）身分提供者元資料',
        description: '使用以下元資料和證書在你的應用程式中配置安全斷言標記語言（SAML）身分提供者。',
        metadata_url_label: '身分提供者元資料網址',
        single_sign_on_service_url_label: '單一登入服務網址',
        idp_entity_id_label: '身分提供者實體識別碼',
    },
    saml_idp_certificates: {
        title: '安全斷言標記語言（SAML）簽名證書',
        expires_at: '到期於',
        finger_print: '指紋',
        status: '狀態',
        active: '啟用',
        inactive: '停用',
    },
    saml_idp_name_id_format: {
        title: '名稱識別碼（NameID）格式',
        description: '選擇安全斷言標記語言（SAML）身分提供者的名稱識別碼（NameID）格式。',
        persistent: '持久',
        persistent_description: '使用 Logto 使用者識別碼作為名稱識別碼',
        transient: '暫時',
        transient_description: '使用一次性使用者識別碼作為名稱識別碼',
        unspecified: '未指定',
        unspecified_description: '使用 Logto 使用者識別碼作為名稱識別碼',
        email_address: '電子郵件地址',
        email_address_description: '使用電子郵件地址作為名稱識別碼',
    },
    saml_encryption_config: {
        encrypt_assertion: '加密安全斷言標記語言（SAML）斷言',
        encrypt_assertion_description: '啟用此選項，安全斷言標記語言（SAML）斷言將被加密。',
        encrypt_then_sign: '加密然後簽名',
        encrypt_then_sign_description: '啟用此選項，安全斷言標記語言（SAML）斷言將被加密後再簽名；否則，安全斷言標記語言（SAML）斷言將先簽名後加密。',
        certificate: '證書',
        certificate_tooltip: '複製並貼上從服務提供者獲得的x509 證書，以加密安全斷言標記語言（SAML）斷言。',
        certificate_placeholder: '-----BEGIN CERTIFICATE-----\nMIICYDCCAcmgAwIBA...\n-----END CERTIFICATE-----\n',
        certificate_missing_error: '需要證書。',
        certificate_invalid_format_error: '檢測到無效的證書格式。請檢查證書格式後重試。',
    },
    saml_app_attribute_mapping: {
        name: '屬性映射',
        title: '基礎屬性映射',
        description: '添加屬性映射以將使用者配置文件從Logto同步到你的應用程式。',
        col_logto_claims: 'Logto的值',
        col_sp_claims: '你應用程式的值名稱',
        add_button: '添加其他',
    },
    concurrent_device_limit,
};
export default Object.freeze(application_details);
